import React, { useRef, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';

// Add Roboto font
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap';
document.head.appendChild(link);

function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Simple password check - hardcoded for now
    if (username === 'admin' && password === 'hotpinkvespa') {
      onLogin();
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: '#282a36',
      flexDirection: 'column',
      fontFamily: 'Roboto, sans-serif',
      position: 'relative'
    }}>
      <div style={{
        backgroundColor: '#44475a',
        borderRadius: '12px',
        padding: '32px',
        border: '2px solid #6272a4',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.3)',
        width: '320px'
      }}>
        <h2 style={{
          margin: '0 0 24px 0',
          color: '#f8f8f2',
          textAlign: 'center',
          fontSize: '28px',
          fontWeight: '700',
          fontFamily: 'Roboto, sans-serif',
          letterSpacing: '0.5px'
        }}>
          Tater
        </h2>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              color: '#f8f8f2',
              fontSize: '14px',
              fontWeight: '500',
              fontFamily: 'Roboto, sans-serif'
            }}>
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#282a36',
                border: '1px solid #6272a4',
                borderRadius: '6px',
                color: '#f8f8f2',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: '400'
              }}
              placeholder="Enter username"
            />
          </div>
          <div>
            <label style={{
              display: 'block',
              marginBottom: '8px',
              color: '#f8f8f2',
              fontSize: '14px',
              fontWeight: '500',
              fontFamily: 'Roboto, sans-serif'
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#282a36',
                border: '1px solid #6272a4',
                borderRadius: '6px',
                color: '#f8f8f2',
                fontSize: '14px',
                outline: 'none',
                boxSizing: 'border-box',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: '400'
              }}
              placeholder="Enter password"
            />
          </div>
          {error && (
            <div style={{
              color: '#ff5555',
              fontSize: '14px',
              textAlign: 'center',
              padding: '8px',
              backgroundColor: '#44475a',
              borderRadius: '4px',
              border: '1px solid #ff5555',
              fontFamily: 'Roboto, sans-serif',
              fontWeight: '400'
            }}>
              {error}
            </div>
          )}
          <button
            type="submit"
            style={{
              padding: '12px',
              backgroundColor: '#6272a4',
              border: 'none',
              borderRadius: '6px',
              color: '#f8f8f2',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '500',
              marginTop: '8px',
              fontFamily: 'Roboto, sans-serif',
              letterSpacing: '0.5px'
            }}
          >
            Login
          </button>
        </form>
      </div>
      {/* Logos at the bottom center, SplitStep left, Wyatt AI right */}
      <div style={{
        position: 'absolute',
        bottom: 24,
        left: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        gap: '32px',
        pointerEvents: 'none',
        flexDirection: 'row',
        alignItems: 'center',
      }}>
        <img src="/images/logo%20SplitStep,%20symbol%2003.png" alt="SplitStep Logo" style={{ height: 48, objectFit: 'contain', filter: 'drop-shadow(0 2px 8px #0008)' }} />
        <img src="/images/logo%20Wyatt%20AI%20wide,%20dark.png" alt="Wyatt AI Logo" style={{ height: 48, objectFit: 'contain', filter: 'drop-shadow(0 2px 8px #0008)' }} />
      </div>
    </div>
  );
}

function VideoPlayer() {
  const videoRef = useRef(null);
  const playerRef = useRef(null);
  const lastKeyPressRef = useRef(0);
  const [annotations, setAnnotations] = useState([]);
  const [annotationMode, setAnnotationMode] = useState('stroke'); // 'stroke', 'bounce', 'in-flight', or 'net'
  const [isPaused, setIsPaused] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [videoDuration, setVideoDuration] = useState(0);
  const [videoUrl, setVideoUrl] = useState('');
  const [zoom, setZoom] = useState(1);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const panRef = useRef(pan);
  const zoomRef = useRef(zoom);
  useEffect(() => { panRef.current = pan; }, [pan]);
  useEffect(() => { zoomRef.current = zoom; }, [zoom]);
  const videoDisplayWidth = 1280; // Back to original size
  const timelineWindow = 20; // 20 second window for high temporal resolution
  // The timeline viewport width always matches the video width
  const timelineViewportWidth = videoDisplayWidth;
  
  // Timeline zoom functionality
  const [timelineZoom, setTimelineZoom] = useState(1); // 1 = normal, 2 = 2x zoom, 0.5 = 2x zoom out
  const [timelineZoomCenter, setTimelineZoomCenter] = useState(0); // Center point of zoom (0-1)
  
  // Calculate the visible time window based on zoom
  // Specific zoom levels: 0.05 (5min), 0.25 (1min), 0.5 (30s), 1 (15s), 2 (7.5s)
  const getTimeWindow = (zoom) => {
    const zoomLevels = [0.05, 0.25, 0.5, 1, 2];
    const timeWindows = [300, 60, 30, 15, 7.5]; // in seconds
    const index = zoomLevels.findIndex(level => Math.abs(level - zoom) < 0.01);
    return index >= 0 ? timeWindows[index] : 15; // default to 15s for 1x
  };
  
  const visibleTimeWindow = getTimeWindow(timelineZoom);
  
  // The inner timeline bar width is proportional to video duration and zoom
  const timelineBarWidth = videoDuration > 0 ? (videoDuration / visibleTimeWindow) * timelineViewportWidth : timelineViewportWidth;

  // Calculate pixels per second for the timeline
  const pxPerSecond = videoDuration > 0 ? timelineBarWidth / videoDuration : 0;

  // Ref for the scrollable timeline
  const timelineScrollRef = useRef(null);
  const [timelineScroll, setTimelineScroll] = useState(0); // 0 to 1

  // Sync scroll position when timelineScroll changes
  useEffect(() => {
    if (!timelineScrollRef.current) return;
    const maxScroll = timelineBarWidth - timelineViewportWidth;
    timelineScrollRef.current.scrollLeft = timelineScroll * maxScroll;
  }, [timelineScroll, timelineBarWidth, timelineViewportWidth]);

  // Sync timelineScroll state when user scrolls timeline
  const handleTimelineScroll = () => {
    if (!timelineScrollRef.current) return;
    const maxScroll = timelineBarWidth - timelineViewportWidth;
    setTimelineScroll(timelineScrollRef.current.scrollLeft / maxScroll);
  };

  // On playhead move, scroll timeline to keep playhead in view
  useEffect(() => {
    if (!timelineScrollRef.current || !videoDuration) return;
    const playheadPx = currentTime * pxPerSecond;
    const scrollLeft = timelineScrollRef.current.scrollLeft;
    const viewportWidth = timelineScrollRef.current.clientWidth;
    if (playheadPx < scrollLeft || playheadPx > scrollLeft + viewportWidth - 40) {
      // Center playhead in viewport
      const maxScroll = timelineBarWidth - timelineViewportWidth;
      const newScroll = Math.max(0, Math.min(playheadPx - viewportWidth / 2, maxScroll));
      timelineScrollRef.current.scrollLeft = newScroll;
      setTimelineScroll(newScroll / maxScroll);
    }
  }, [currentTime, pxPerSecond, videoDuration, timelineBarWidth, timelineViewportWidth]);

  // Reset timeline zoom when video changes
  useEffect(() => {
    resetTimelineZoom();
  }, [videoUrl]);

  // Reset timeline zoom
  const resetTimelineZoom = () => {
    setTimelineZoom(1);
    setTimelineZoomCenter(0);
  };

  // Handle timeline click (relative to full timeline)
  const handleTimelineClick = (event) => {
    if (!playerRef.current || !videoDuration) return;
    const rect = event.currentTarget.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    
    // Account for scroll position
    const scrollLeft = timelineScrollRef.current?.scrollLeft || 0;
    const adjustedClickX = clickX + scrollLeft;
    
    // Calculate time based on the full timeline width and zoom
    const clickTime = (adjustedClickX / timelineBarWidth) * videoDuration;
    const clampedTime = Math.max(0, Math.min(clickTime, videoDuration));
    
    playerRef.current.currentTime(clampedTime);
  };

  // Handle timeline zoom
  const handleTimelineZoom = (delta, centerX) => {
    if (!videoDuration) return;
    
    // Define specific zoom levels and their corresponding time windows
    const zoomLevels = [0.05, 0.25, 0.5, 1, 2];
    const timeWindows = [300, 60, 30, 15, 7.5]; // in seconds
    
    // Find current zoom level index
    const currentIndex = zoomLevels.findIndex(level => Math.abs(level - timelineZoom) < 0.01);
    let newIndex = currentIndex;
    
    if (delta > 0) {
      // Zoom in
      newIndex = Math.min(zoomLevels.length - 1, currentIndex + 1);
    } else {
      // Zoom out
      newIndex = Math.max(0, currentIndex - 1);
    }
    
    const newZoom = zoomLevels[newIndex];
    if (newZoom === timelineZoom) return;
    
    // Calculate the center point of the zoom in timeline coordinates
    const rect = timelineScrollRef.current?.getBoundingClientRect();
    if (!rect) return;
    
    const timelineCenterX = centerX - rect.left;
    const scrollLeft = timelineScrollRef.current?.scrollLeft || 0;
    const adjustedCenterX = timelineCenterX + scrollLeft;
    const timelineCenterTime = (adjustedCenterX / timelineBarWidth) * videoDuration;
    const newCenter = timelineCenterTime / videoDuration;
    
    setTimelineZoom(newZoom);
    setTimelineZoomCenter(newCenter);
    
    // Adjust scroll position to keep the center point in view
    setTimeout(() => {
      if (timelineScrollRef.current) {
        const newTimeWindow = timeWindows[newIndex];
        const newTimelineBarWidth = videoDuration > 0 ? (videoDuration / newTimeWindow) * timelineViewportWidth : timelineViewportWidth;
        const newCenterPx = newCenter * newTimelineBarWidth;
        const newScrollLeft = newCenterPx - (timelineViewportWidth / 2);
        const maxScroll = Math.max(0, newTimelineBarWidth - timelineViewportWidth);
        timelineScrollRef.current.scrollLeft = Math.max(0, Math.min(newScrollLeft, maxScroll));
      }
    }, 0);
  };

  // Handle timeline wheel zoom
  const handleTimelineWheel = (event) => {
    event.preventDefault();
    const delta = event.deltaY > 0 ? -1 : 1;
    handleTimelineZoom(delta, event.clientX);
  };

  // Play/Pause Button ref
  const playButtonRef = useRef(null);

  // Handle video URL input
  const handleVideoUrlChange = (e) => {
    setVideoUrl(e.target.value);
  };

  const handleVideoUrlSubmit = (e) => {
    e.preventDefault();
    if (videoUrl.trim() && playerRef.current) {
      // Clear existing annotations when loading new video
      setAnnotations([]);
      setCurrentTime(0);
      setVideoDuration(0);
      
      // Update video source
      playerRef.current.src({
        src: videoUrl.trim(),
        type: 'video/mp4'
      });
      
      // Load and play the new video
      playerRef.current.load();
      playerRef.current.play();
    }
  };

  useEffect(() => {
    // Only initialize or update the player if a videoUrl is set
    if (!videoUrl) return;

    if (!playerRef.current) {
      const videoElement = videoRef.current;
      if (!videoElement) {
        return;
      }
      
      // Use native HTML5 video instead of VideoJS to avoid cursor issues
      videoElement.src = videoUrl;
      videoElement.muted = true;
      videoElement.style.cursor = 'crosshair';
      
      // Set up native video event listeners
      videoElement.addEventListener('play', () => setIsPaused(false));
      videoElement.addEventListener('pause', () => setIsPaused(true));
      videoElement.addEventListener('timeupdate', () => {
        setCurrentTime(videoElement.currentTime);
      });
      videoElement.addEventListener('loadedmetadata', () => {
        setVideoDuration(videoElement.duration);
      });
      
      // Store reference to native element
      playerRef.current = {
        currentTime: (time) => {
          if (time !== undefined) {
            videoElement.currentTime = time;
          }
          return videoElement.currentTime;
        },
        duration: () => videoElement.duration,
        paused: () => videoElement.paused,
        play: () => videoElement.play(),
        pause: () => videoElement.pause(),
        src: (src) => {
          if (src) {
            videoElement.src = src.src;
          }
        },
        load: () => videoElement.load(),
        readyState: () => videoElement.readyState,
        dispose: () => {
          videoElement.removeEventListener('play', () => setIsPaused(false));
          videoElement.removeEventListener('pause', () => setIsPaused(true));
          videoElement.removeEventListener('timeupdate', () => {});
          videoElement.removeEventListener('loadedmetadata', () => {});
        }
      };
      
      // Load and play the video
      videoElement.load();
      videoElement.play();
    } else {
      // If already initialized, just update the source
      const videoElement = videoRef.current;
      videoElement.src = videoUrl;
      videoElement.load();
      videoElement.play();
    }
    // Cleanup function
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, [videoUrl]);

  // Update annotation type when mode changes
  useEffect(() => {
    const fps = 30;
    const tolerance = 1 / fps / 2; // Half a frame tolerance
    
    setAnnotations(prev => prev.map(ann => 
      Math.abs(ann.timestamp - currentTime) < tolerance
        ? { ...ann, type: annotationMode }
        : ann
    ));
  }, [annotationMode]);

  // Reset zoom when video starts playing
  useEffect(() => {
    if (!isPaused && (zoom !== 1 || pan.x !== 0 || pan.y !== 0)) {
      setZoom(1);
      setPan({ x: 0, y: 0 });
    }
  }, [isPaused, zoom, pan.x, pan.y]);

  // Format time for display and JSON
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    const ms = Math.floor((seconds % 1) * 100);
    return `${mins}:${secs.toString().padStart(2, '0')}.${ms.toString().padStart(2, '0')}`;
  };

  // Parse formatted time string back to seconds
  const parseFormattedTime = (timeStr) => {
    const [minutesPart, secondsPart] = timeStr.split(':');
    const [seconds, centiseconds] = secondsPart.split('.');
    return parseInt(minutesPart) * 60 + parseInt(seconds) + parseInt(centiseconds) / 100;
  };

  // Add player side switch state
  const [sideSwitches, setSideSwitches] = useState([]);

  // Function to add or remove a side switch
  const toggleSideSwitch = () => {
    const fps = 30;
    const tolerance = 1 / fps / 2; // Half a frame tolerance
    
    // Check if there's already a switch at this time
    const existingSwitch = sideSwitches.find(sw => 
      Math.abs(sw.timestamp - currentTime) < tolerance
    );
    
    if (existingSwitch) {
      // Remove the switch
      setSideSwitches(prev => prev.filter(sw => 
        Math.abs(sw.timestamp - currentTime) > tolerance
      ));
    } else {
      // Get the previous switch to determine current colors
      const previousSwitches = sideSwitches
        .filter(sw => sw.timestamp < currentTime)
        .sort((a, b) => b.timestamp - a.timestamp);

      // Get current top player color from previous switches or default to red
      const currentTop = previousSwitches.length > 0 
        ? previousSwitches[0].topPlayer 
        : 'red';

      // Add new switch with opposite colors
      const newSwitch = {
        id: Date.now(),
        timestamp: currentTime, // Use current time directly since it's now at frame boundary
        topPlayer: currentTop === 'red' ? 'green' : 'red'
      };

      // Add to list and sort by timestamp
      setSideSwitches(prev => [...prev, newSwitch].sort((a, b) => a.timestamp - b.timestamp));
    }
  };

  // Get current player sides based on timeline position
  const getCurrentPlayerSides = (time) => {
    const previousSwitches = sideSwitches
      .filter(sw => sw.timestamp <= time)
      .sort((a, b) => b.timestamp - a.timestamp);
    
    if (previousSwitches.length === 0) {
      return { top: 'red', bottom: 'green' };
    }
    
    const lastSwitch = previousSwitches[0];
    return {
      top: lastSwitch.topPlayer,
      bottom: lastSwitch.topPlayer === 'red' ? 'green' : 'red'
    };
  };

  // Calculate current player sides
  const currentSides = getCurrentPlayerSides(currentTime);

  // Add keyboard shortcut for side switching
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Prevent rapid key presses (debounce)
      const now = Date.now();
      if (now - lastKeyPressRef.current < 50) {
        return;
      }
      lastKeyPressRef.current = now;
      if (!playerRef.current) {
        return;
      }
      // Check if player is ready
      if (playerRef.current.readyState() < 2) {
        return;
      }
      const fps = 30;
      const frameTime = 1 / fps;
      const skipFrames = event.shiftKey ? 5 : 1;
      const skipTime = frameTime * skipFrames;
      
      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          event.stopPropagation();
          const newTimeBack = Math.max(0, playerRef.current.currentTime() - skipTime);
          const snappedTimeBack = snapToFrame(newTimeBack);
          playerRef.current.currentTime(snappedTimeBack);
          break;
        case 'ArrowRight':
          event.preventDefault();
          event.stopPropagation();
          const newTimeForward = playerRef.current.currentTime() + skipTime;
          const snappedTimeForward = snapToFrame(newTimeForward);
          playerRef.current.currentTime(snappedTimeForward);
          break;
        case 'Tab':
          event.preventDefault();
          event.stopPropagation();
          setAnnotationMode(prev => {
            const modes = ['stroke', 'bounce', 'in-flight', 'net'];
            const currentIndex = modes.indexOf(prev);
            return modes[(currentIndex + 1) % modes.length];
          });
          break;
        case 'x':
        case 'X':
          event.preventDefault();
          event.stopPropagation();
          const tolerance = 1 / fps / 2; // Half a frame tolerance
          setAnnotations(prev => prev.filter(ann => 
            Math.abs(ann.timestamp - currentTime) > tolerance
          ));
          break;
        case ' ':
          event.preventDefault();
          event.stopPropagation();
          if (playerRef.current.paused()) {
            playerRef.current.play();
          } else {
            // When pausing, snap to nearest frame boundary
            const currentTime = playerRef.current.currentTime();
            const snappedTime = snapToFrame(currentTime);
            playerRef.current.currentTime(snappedTime);
            playerRef.current.pause();
          }
          break;
        case 's':
        case 'S':
          event.preventDefault();
          event.stopPropagation();
          saveAnnotations();
          break;
        case 'p':
        case 'P':
          // Add side switch shortcut
          event.preventDefault();
          event.stopPropagation();
          if (isPaused) {
            toggleSideSwitch();
          }
          break;
      }
    };
    document.addEventListener('keydown', handleKeyDown, true);
    return () => {
      document.removeEventListener('keydown', handleKeyDown, true);
    };
  }, [currentTime, isPaused, annotations, videoDuration, sideSwitches]);

  // Modify saveAnnotations to include side switches
  const saveAnnotations = () => {
    const fps = 30;
    const videoElement = videoRef.current;
    const actualVideoWidth = videoElement ? videoElement.videoWidth : 1280;
    const actualVideoHeight = videoElement ? videoElement.videoHeight : 720;
    
    let videoFilename = '';
    try {
      if (videoUrl) {
        const urlWithoutParams = videoUrl.split('?')[0];
        const urlParts = urlWithoutParams.split('/');
        const lastPart = urlParts[urlParts.length - 1];
        if (lastPart.toLowerCase().endsWith('.mp4')) {
          videoFilename = lastPart;
        }
      }
    } catch (error) {
      console.warn('Could not extract video filename from URL:', error);
    }

    const annotationsData = annotations.map(annotation => ({
      time: annotation.timestamp, // Store time in seconds directly
      timestamp: formatTime(annotation.timestamp), // Keep formatted version for display
      x: Math.round(annotation.x),
      y: Math.round(annotation.y),
      type: annotation.type
    }));

    const sideSwitchesData = sideSwitches.map(sw => ({
      time: sw.timestamp, // Store time in seconds directly
      timestamp: formatTime(sw.timestamp), // Keep formatted version for display
      type: 'side_switch'
    }));

    const data = {
      video_filename: videoFilename,
      video_width: actualVideoWidth,
      video_height: actualVideoHeight,
      fps: fps,
      total_frames: Math.floor(videoDuration * fps),
      total_duration: formatTime(videoDuration),
      annotations: [...annotationsData, ...sideSwitchesData]
    };

    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    
    const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
    const a = document.createElement('a');
    a.href = url;
    a.download = videoFilename ? `${videoFilename}_annotations_${timestamp}.json` : `annotations_${timestamp}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // Helper function to snap time to nearest frame boundary
  const snapToFrame = (timestamp, fps = 30) => {
    return Math.round(timestamp * fps) / fps;
  };

  // Helper function to round timestamp to nearest frame boundary
  const roundToFrame = (timestamp, fps = 30) => {
    return Math.floor(timestamp * fps) / fps;
  };

  // Handle play/pause button click with frame snapping
  const handlePlayPauseClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (playButtonRef.current) playButtonRef.current.blur();
    if (!playerRef.current) return;
    
    const actuallyPaused = playerRef.current.paused();
    if (actuallyPaused) {
      playerRef.current.play();
    } else {
      // When pausing, snap to nearest frame boundary
      const currentTime = playerRef.current.currentTime();
      const snappedTime = snapToFrame(currentTime);
      playerRef.current.currentTime(snappedTime);
      playerRef.current.pause();
    }
  };

  // Handle click on annotation layer (convert to video coordinates)
  const handleAnnotationClick = (event) => {
    if (!isPaused) return; // Only allow annotations when paused
    const rect = event.currentTarget.getBoundingClientRect();
    const videoElement = videoRef.current;
    const displayWidth = 1280;
    const displayHeight = 720;
    const nativeWidth = videoElement ? videoElement.videoWidth : displayWidth;
    const nativeHeight = videoElement ? videoElement.videoHeight : displayHeight;
    // Use refs to get the latest pan/zoom values
    const x = (event.clientX - rect.left + panRef.current.x) / zoomRef.current;
    const y = (event.clientY - rect.top + panRef.current.y) / zoomRef.current;
    // Clamp coordinates to display bounds
    const clampedX = Math.max(0, Math.min(x, displayWidth));
    const clampedY = Math.max(0, Math.min(y, displayHeight));
    // Convert to native video coordinates
    const nativeX = (clampedX / displayWidth) * nativeWidth;
    const nativeY = (clampedY / displayHeight) * nativeHeight;
    const fps = 30;
    const tolerance = 1 / fps / 2; // Half a frame tolerance
    const existingAnnotation = annotations.find(ann => 
      Math.abs(ann.timestamp - currentTime) < tolerance
    );
    if (existingAnnotation) {
      setAnnotations(prev => prev.map(ann => 
        Math.abs(ann.timestamp - currentTime) < tolerance
          ? { ...ann, x: nativeX, y: nativeY, type: annotationMode }
          : ann
      ));
    } else {
      const newAnnotation = {
        id: Date.now(),
        x: nativeX,
        y: nativeY,
        type: annotationMode,
        timestamp: playerRef.current.currentTime() // Use video's actual time instead of React state
      };
      setAnnotations(prev => [...prev, newAnnotation]);
    }
  };

  // Get all annotations for the current frame (timestamp-based matching with consistent tolerance)
  const fps = 30;
  const frameDuration = 1 / fps;
  const tolerance = frameDuration / 2; // Half a frame tolerance for precise matching
  const roundedCurrentTime = roundToFrame(currentTime);
  const currentAnnotations = annotations.filter(ann => 
    Math.abs(ann.timestamp - roundedCurrentTime) < tolerance
  );

  // Format frame for display
  const formatFrame = (seconds) => {
    const fps = 30;
    const frame = Math.floor(seconds * fps);
    const totalFrames = Math.floor(videoDuration * fps);
    return `${frame} / ${totalFrames}`;
  };

  // Count annotations by type
  const strokeCount = annotations.filter(ann => ann.type === 'stroke').length;
  const bounceCount = annotations.filter(ann => ann.type === 'bounce').length;
  const inFlightCount = annotations.filter(ann => ann.type === 'in-flight').length;
  const netCount = annotations.filter(ann => ann.type === 'net').length;

  const [loadedFileName, setLoadedFileName] = useState('');
  const [uploadError, setUploadError] = useState('');

  // Handle annotation file upload
  const handleAnnotationUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const data = JSON.parse(event.target.result);
        if (!Array.isArray(data.annotations)) throw new Error('No annotations array');
        
        // Get current video dimensions
        const videoElement = videoRef.current;
        const currentVideoWidth = videoElement ? videoElement.videoWidth : 1280;
        const currentVideoHeight = videoElement ? videoElement.videoHeight : 720;
        
        // Get saved video dimensions (default to current if not available)
        const savedVideoWidth = data.video_width || currentVideoWidth;
        const savedVideoHeight = data.video_height || currentVideoHeight;
        
        // Convert frame numbers to timestamps (assuming 30 fps)
        const fps = data.fps || 30;
        
        // Separate regular annotations from side switches
        const regularAnnotations = [];
        const loadedSideSwitches = [];
        
        data.annotations.forEach((a, i) => {
          // Always use the raw time field for precise timestamps, then round to frame boundary
          let timestamp = roundToFrame(a.time || 0);
          
          if (a.type === 'side_switch') {
            // Handle side switch
            loadedSideSwitches.push({
              id: a.id || Date.now() + i,
              timestamp: timestamp,
              topPlayer: a.top_player
            });
          } else {
            // Handle regular annotation
            const displayWidth = 1280;
            const displayHeight = 720;
            const displayX = (a.x / savedVideoWidth) * displayWidth;
            const displayY = (a.y / savedVideoHeight) * displayHeight;
            const nativeX = (displayX / displayWidth) * currentVideoWidth;
            const nativeY = (displayY / displayHeight) * currentVideoHeight;
            regularAnnotations.push({
              id: a.id || Date.now() + i,
              x: nativeX,
              y: nativeY,
              type: a.type || a.ball_type, // Handle both new and old field names
              timestamp: timestamp
            });
          }
        });
        
        setAnnotations(regularAnnotations);
        setSideSwitches(loadedSideSwitches);
        setLoadedFileName(file.name);
        setUploadError('');
      } catch (err) {
        console.error('Error loading annotations:', err);
        setUploadError('Invalid annotation file.');
        setLoadedFileName('');
      }
    };
    reader.readAsText(file);
    // Reset file input so the same file can be uploaded again if needed
    e.target.value = '';
  };

  // Clear loaded annotations
  const handleClearAnnotations = () => {
    setAnnotations([]);
    setLoadedFileName('');
    setUploadError('');
  };

  // Mouse wheel for zoom (mouse-centered)
  const handleWheel = (e) => {
    if (!isPaused) return;
    e.preventDefault();
    
    let newZoom = zoom + (e.deltaY < 0 ? 0.1 : -0.1);
    newZoom = Math.max(1, Math.min(4, newZoom));
    if (newZoom === zoom) return;
    
    const rect = e.currentTarget.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    
    // Calculate the video-space coordinates under the mouse before zoom
    const videoX = (mouseX + pan.x) / zoom;
    const videoY = (mouseY + pan.y) / zoom;
    
    // Calculate new pan so that (videoX, videoY) stays under the mouse
    let newPanX = videoX * newZoom - mouseX;
    let newPanY = videoY * newZoom - mouseY;
    
    // Clamp pan so you can't see outside the video
    const maxPanX = Math.max(0, 1280 * (newZoom - 1));
    const maxPanY = Math.max(0, 720 * (newZoom - 1));
    newPanX = Math.max(0, Math.min(newPanX, maxPanX));
    newPanY = Math.max(0, Math.min(newPanY, maxPanY));
    
    setZoom(newZoom);
    setPan({ x: newPanX, y: newPanY });
  };

  // Add global CSS to disable grab cursors immediately
  useEffect(() => {
    const globalStyle = document.createElement('style');
    globalStyle.id = 'global-cursor-override';
    globalStyle.textContent = `
      /* Only override cursor on video-related elements, not globally */
      video, .video-js, .video-wrapper, .vjs-tech {
        cursor: ${isPaused ? 'crosshair' : 'default'} !important;
      }
      
      /* Keep pointer for buttons */
      button, 
      input[type="button"], 
      input[type="submit"],
      .vjs-big-play-button {
        cursor: pointer !important;
      }
      
      /* Override any inline cursor styles on video elements */
      video[style*="cursor: grab"],
      video[style*="cursor: grabbing"],
      video[style*="cursor: move"],
      video[style*="cursor: hand"],
      .video-wrapper[style*="cursor: grab"],
      .video-wrapper[style*="cursor: grabbing"],
      .video-wrapper[style*="cursor: move"],
      .video-wrapper[style*="cursor: hand"] {
        cursor: ${isPaused ? 'crosshair' : 'default'} !important;
      }
    `;
    document.head.appendChild(globalStyle);
    
    return () => {
      const existing = document.getElementById('global-cursor-override');
      if (existing) {
        document.head.removeChild(existing);
      }
    };
  }, [isPaused]); // Add isPaused dependency

  // Direct cursor override on video element
  useEffect(() => {
    if (videoRef.current) {
      const videoElement = videoRef.current;
      const setCursor = () => {
        try {
          if (videoElement && videoElement.style) {
            videoElement.style.cursor = 'crosshair';
            // Also set on parent elements
            let parent = videoElement.parentElement;
            while (parent && parent.style) {
              parent.style.cursor = 'crosshair';
              parent = parent.parentElement;
            }
          }
        } catch (error) {
          console.log('Direct cursor override error:', error);
        }
      };
      
      setCursor();
      
      // Set up a mutation observer to catch any cursor changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            setCursor();
          }
        });
      });
      
      observer.observe(videoElement, { attributes: true, attributeFilter: ['style'] });
      
      return () => observer.disconnect();
    }
  }, []); // Remove videoRef.current dependency

  return (
    <div 
      style={{ 
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        height: '100vh',
        background: '#282a36',
        fontFamily: 'Roboto, sans-serif',
        padding: '20px 20px 40px 20px',
        boxSizing: 'border-box',
        gap: '40px',
        overflow: 'hidden',
        width: '100vw',
        position: 'relative'
      }}
      tabIndex={0}
    >
      {/* Left Controls Column */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: '20px',
        zIndex: 1000,
        flexShrink: 0,
        width: '400px' // Fixed width to prevent expansion
      }}>
        {/* Video URL Input Box */}
        <div style={{
          backgroundColor: '#44475a',
          borderRadius: '8px',
          padding: '12px',
          border: '2px solid #6272a4',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          fontFamily: 'Roboto, sans-serif',
        }}>
          <form onSubmit={handleVideoUrlSubmit} style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
            <input
              type="text"
              value={videoUrl}
              onChange={handleVideoUrlChange}
              placeholder="Paste video URL here..."
              style={{
                flex: 1, // Take up remaining space
                padding: '8px 12px',
                backgroundColor: '#282a36',
                border: '1px solid #6272a4',
                borderRadius: '4px',
                color: '#f8f8f2',
                fontSize: '14px',
                outline: 'none',
                fontFamily: 'Roboto, sans-serif',
                fontWeight: '400'
              }}
            />
            <button
              type="submit"
              style={{
                padding: '8px 16px',
                backgroundColor: '#6272a4',
                border: 'none',
                borderRadius: '4px',
                color: '#f8f8f2',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                whiteSpace: 'nowrap',
                fontFamily: 'Roboto, sans-serif',
                letterSpacing: '0.3px'
              }}
            >
              Load
            </button>
          </form>
        </div>
        {/* Upload Annotations Button and Loaded Message */}
        <div style={{ 
          width: '100%',
          boxSizing: 'border-box',
          display: 'flex', 
          alignItems: 'center', 
          gap: '0', 
          height: '32px',
        }}>
          <div style={{
            backgroundColor: '#44475a',
            borderRadius: '6px',
            padding: '6px 12px',
            border: uploadError ? '2px solid #ff5555' : '2px solid #6272a4',
            display: 'flex',
            alignItems: 'center',
            gap: '0',
            boxShadow: '0 2px 8px #0002',
            minHeight: '28px',
            width: '100%', // Fill parent width
            boxSizing: 'border-box',
            flexShrink: 0
          }}>
            <label style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              padding: '4px',
              borderRadius: '4px',
              transition: 'background-color 0.2s',
              width: '32px',
              flexShrink: 0,
              justifyContent: 'center'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#343746'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 3V13M10 13L6 9M10 13L14 9" stroke="#bd93f9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <input type="file" accept="application/json" style={{ display: 'none' }} onChange={handleAnnotationUpload} />
            </label>
            <div style={{ 
              flex: 1, 
              minWidth: 0, 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between',
              maxWidth: 'calc(100% - 32px)' // Account for the upload button width
            }}>
            {uploadError ? (
                <span style={{ 
                  color: '#ff5555', 
                  fontSize: '14px', 
                  fontWeight: 500, 
                  fontFamily: 'Roboto, sans-serif', 
                  flex: 1, 
                  minWidth: 0,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                {uploadError}
              </span>
            ) : loadedFileName ? (
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'space-between',
                  flex: 1,
                  minWidth: 0, // This is important for text-overflow to work
                  maxWidth: '100%'
                }}>
                  <span style={{ 
                    color: '#50fa7b', 
                    fontSize: '14px', 
                    fontWeight: 500, 
                    fontFamily: 'Roboto, sans-serif',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    marginRight: '8px',
                    flex: 1,
                    minWidth: 0,
                    maxWidth: 'calc(100% - 50px)' // Leave space for the Clear button
                  }}>
                  Loaded: {loadedFileName}
                </span>
                  <button 
                    onClick={handleClearAnnotations} 
                    style={{
                  background: 'none',
                  border: 'none',
                  color: '#ff5555',
                  fontWeight: 700,
                  fontSize: '14px',
                  cursor: 'pointer',
                  padding: '0 4px',
                      fontFamily: 'Roboto, sans-serif',
                      flexShrink: 0, // Prevent the Clear button from shrinking
                      minWidth: '42px' // Fixed width for the Clear button
                    }}
                  >
                    Clear
                  </button>
                </div>
            ) : (
                <span style={{ 
                  color: '#6272a4', 
                  fontSize: '14px', 
                  fontWeight: 400, 
                  fontFamily: 'Roboto, sans-serif',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  flex: 1,
                  minWidth: 0
                }}>
                No annotations loaded
              </span>
            )}
            </div>
          </div>
        </div>
        {/* Annotation Counters */}
        <div style={{
          backgroundColor: '#44475a',
          borderRadius: '8px',
          padding: '16px',
          border: '2px solid #6272a4',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          fontFamily: 'Roboto, sans-serif',
          width: '360px'
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {/* Current Mode Row */}
            <div style={{
              fontWeight: 700,
              fontSize: '15px',
              fontFamily: 'Roboto, sans-serif',
              color: '#f8f8f2',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              width: '100%',
              justifyContent: 'center',
              paddingBottom: '8px',
              borderBottom: '1px solid #6272a4',
              marginBottom: '4px'
            }}>
              Current Mode:
              <span style={{ 
                color: annotationMode === 'stroke' ? '#ffb86c' : 
                       annotationMode === 'bounce' ? '#8be9fd' :
                       annotationMode === 'in-flight' ? '#ff79c6' : '#bd93f9',
                fontWeight: 700,
                display: 'inline-block',
                width: '80px',
                textAlign: 'left',
                marginLeft: '4px'
              }}>
                {annotationMode.charAt(0).toUpperCase() + annotationMode.slice(1)}
              </span>
            </div>
            {/* First Row */}
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  border: '2px solid #ffb86c',
                  backgroundColor: 'transparent'
                }} />
                <span style={{ color: '#f8f8f2', fontSize: '14px', fontWeight: '500', fontFamily: 'Roboto, sans-serif', minWidth: '80px' }}>
                  Strokes: {strokeCount}
                </span>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <button
                    onClick={() => {
                      const prevStroke = annotations
                        .filter(a => a.timestamp < currentTime && a.type === 'stroke')
                        .sort((a, b) => b.timestamp - a.timestamp)[0];
                      if (prevStroke && playerRef.current) {
                        playerRef.current.currentTime(prevStroke.timestamp);
                      }
                    }}
                    disabled={annotations.filter(a => a.timestamp < currentTime && a.type === 'stroke').length === 0}
                    style={{
                      width: '20px',
                      height: '20px',
                      padding: 0,
                      background: 'none',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: annotations.filter(a => a.timestamp < currentTime && a.type === 'stroke').length === 0 ? 'not-allowed' : 'pointer',
                      opacity: annotations.filter(a => a.timestamp < currentTime && a.type === 'stroke').length === 0 ? 0.4 : 1,
                    }}
                    title="Previous Stroke"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 4L6 8L10 12" stroke="#ffb86c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button
                    onClick={() => {
                      const nextStroke = annotations
                        .filter(a => a.timestamp > currentTime && a.type === 'stroke')
                        .sort((a, b) => a.timestamp - b.timestamp)[0];
                      if (nextStroke && playerRef.current) {
                        playerRef.current.currentTime(nextStroke.timestamp);
                      }
                    }}
                    disabled={annotations.filter(a => a.timestamp > currentTime && a.type === 'stroke').length === 0}
                    style={{
                      width: '20px',
                      height: '20px',
                      padding: 0,
                      background: 'none',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: annotations.filter(a => a.timestamp > currentTime && a.type === 'stroke').length === 0 ? 'not-allowed' : 'pointer',
                      opacity: annotations.filter(a => a.timestamp > currentTime && a.type === 'stroke').length === 0 ? 0.4 : 1,
                    }}
                    title="Next Stroke"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 4L10 8L6 12" stroke="#ffb86c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  border: '2px solid #8be9fd',
                  backgroundColor: 'transparent'
                }} />
                <span style={{ color: '#f8f8f2', fontSize: '14px', fontWeight: '500', fontFamily: 'Roboto, sans-serif', minWidth: '80px' }}>
                  Bounces: {bounceCount}
                </span>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <button
                    onClick={() => {
                      const prevBounce = annotations
                        .filter(a => a.timestamp < currentTime && a.type === 'bounce')
                        .sort((a, b) => b.timestamp - a.timestamp)[0];
                      if (prevBounce && playerRef.current) {
                        playerRef.current.currentTime(prevBounce.timestamp);
                      }
                    }}
                    disabled={annotations.filter(a => a.timestamp < currentTime && a.type === 'bounce').length === 0}
                    style={{
                      width: '20px',
                      height: '20px',
                      padding: 0,
                      background: 'none',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: annotations.filter(a => a.timestamp < currentTime && a.type === 'bounce').length === 0 ? 'not-allowed' : 'pointer',
                      opacity: annotations.filter(a => a.timestamp < currentTime && a.type === 'bounce').length === 0 ? 0.4 : 1,
                    }}
                    title="Previous Bounce"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 4L6 8L10 12" stroke="#8be9fd" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button
                    onClick={() => {
                      const nextBounce = annotations
                        .filter(a => a.timestamp > currentTime && a.type === 'bounce')
                        .sort((a, b) => a.timestamp - b.timestamp)[0];
                      if (nextBounce && playerRef.current) {
                        playerRef.current.currentTime(nextBounce.timestamp);
                      }
                    }}
                    disabled={annotations.filter(a => a.timestamp > currentTime && a.type === 'bounce').length === 0}
                    style={{
                      width: '20px',
                      height: '20px',
                      padding: 0,
                      background: 'none',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: annotations.filter(a => a.timestamp > currentTime && a.type === 'bounce').length === 0 ? 'not-allowed' : 'pointer',
                      opacity: annotations.filter(a => a.timestamp > currentTime && a.type === 'bounce').length === 0 ? 0.4 : 1,
                    }}
                    title="Next Bounce"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 4L10 8L6 12" stroke="#8be9fd" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
              </div>
            </div>
            </div>
            {/* Second Row */}
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  border: '2px solid #ff79c6',
                  backgroundColor: 'transparent'
                }} />
                <span style={{ color: '#f8f8f2', fontSize: '14px', fontWeight: '500', fontFamily: 'Roboto, sans-serif', minWidth: '80px' }}>
                  In-Flight: {inFlightCount}
                </span>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <button
                    onClick={() => {
                      const prevInFlight = annotations
                        .filter(a => a.timestamp < currentTime && a.type === 'in-flight')
                        .sort((a, b) => b.timestamp - a.timestamp)[0];
                      if (prevInFlight && playerRef.current) {
                        playerRef.current.currentTime(prevInFlight.timestamp);
                      }
                    }}
                    disabled={annotations.filter(a => a.timestamp < currentTime && a.type === 'in-flight').length === 0}
                    style={{
                      width: '20px',
                      height: '20px',
                      padding: 0,
                      background: 'none',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: annotations.filter(a => a.timestamp < currentTime && a.type === 'in-flight').length === 0 ? 'not-allowed' : 'pointer',
                      opacity: annotations.filter(a => a.timestamp < currentTime && a.type === 'in-flight').length === 0 ? 0.4 : 1,
                    }}
                    title="Previous In-Flight"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 4L6 8L10 12" stroke="#ff79c6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button
                    onClick={() => {
                      const nextInFlight = annotations
                        .filter(a => a.timestamp > currentTime && a.type === 'in-flight')
                        .sort((a, b) => a.timestamp - b.timestamp)[0];
                      if (nextInFlight && playerRef.current) {
                        playerRef.current.currentTime(nextInFlight.timestamp);
                      }
                    }}
                    disabled={annotations.filter(a => a.timestamp > currentTime && a.type === 'in-flight').length === 0}
                    style={{
                      width: '20px',
                      height: '20px',
                      padding: 0,
                      background: 'none',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: annotations.filter(a => a.timestamp > currentTime && a.type === 'in-flight').length === 0 ? 'not-allowed' : 'pointer',
                      opacity: annotations.filter(a => a.timestamp > currentTime && a.type === 'in-flight').length === 0 ? 0.4 : 1,
                    }}
                    title="Next In-Flight"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 4L10 8L6 12" stroke="#ff79c6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  border: '2px solid #bd93f9',
                  backgroundColor: 'transparent'
                }} />
                <span style={{ color: '#f8f8f2', fontSize: '14px', fontWeight: '500', fontFamily: 'Roboto, sans-serif', minWidth: '80px' }}>
                  Net: {netCount}
              </span>
                <div style={{ display: 'flex', gap: '4px' }}>
                  <button
                    onClick={() => {
                      const prevNet = annotations
                        .filter(a => a.timestamp < currentTime && a.type === 'net')
                        .sort((a, b) => b.timestamp - a.timestamp)[0];
                      if (prevNet && playerRef.current) {
                        playerRef.current.currentTime(prevNet.timestamp);
                      }
                    }}
                    disabled={annotations.filter(a => a.timestamp < currentTime && a.type === 'net').length === 0}
                    style={{
                      width: '20px',
                      height: '20px',
                      padding: 0,
                      background: 'none',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: annotations.filter(a => a.timestamp < currentTime && a.type === 'net').length === 0 ? 'not-allowed' : 'pointer',
                      opacity: annotations.filter(a => a.timestamp < currentTime && a.type === 'net').length === 0 ? 0.4 : 1,
                    }}
                    title="Previous Net"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 4L6 8L10 12" stroke="#bd93f9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button
                    onClick={() => {
                      const nextNet = annotations
                        .filter(a => a.timestamp > currentTime && a.type === 'net')
                        .sort((a, b) => a.timestamp - b.timestamp)[0];
                      if (nextNet && playerRef.current) {
                        playerRef.current.currentTime(nextNet.timestamp);
                      }
                    }}
                    disabled={annotations.filter(a => a.timestamp > currentTime && a.type === 'net').length === 0}
                    style={{
                      width: '20px',
                      height: '20px',
                      padding: 0,
                      background: 'none',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: annotations.filter(a => a.timestamp > currentTime && a.type === 'net').length === 0 ? 'not-allowed' : 'pointer',
                      opacity: annotations.filter(a => a.timestamp > currentTime && a.type === 'net').length === 0 ? 0.4 : 1,
                    }}
                    title="Next Net"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 4L10 8L6 12" stroke="#bd93f9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Keyboard Shortcuts Reference */}
        <div style={{
          backgroundColor: '#282a36',
          borderRadius: '8px',
          padding: '0',
          border: '2px solid #6272a4',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          fontFamily: 'Roboto, sans-serif',
          overflow: 'hidden'
        }}>
          <div style={{
            background: '#44475a',
            padding: '12px 20px',
            borderBottom: '1px solid #6272a4',
            fontWeight: 700,
            fontSize: '15px',
            color: '#f8f8f2',
            letterSpacing: '0.5px',
            display: 'flex',
            justifyContent: 'space-between'
          }}>
            <span>Command</span>
            <span>Keybinding</span>
          </div>
          <div style={{ padding: '8px 20px 12px 20px' }}>
            {[
              { cmd: 'Play/Pause', keys: [['Space']] },
              { cmd: 'Frame by frame', keys: [['←'], ['→']] },
              { cmd: 'Skip 5 frames', keys: [['Shift', '+', '←', '→']] },
              { cmd: 'Switch mode', keys: [['Tab']] },
              { cmd: 'Remove annotation', keys: [['X']] },
              { cmd: 'Save annotations', keys: [['S']] },
              { cmd: 'Switch sides', keys: [['P']] },
              { cmd: 'Add annotation', keys: [['POINTER_ICON']] },
            ].map((row, i) => (
              <div key={i} style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: i === 10 ? 'none' : '1px solid #343746',
                padding: '7px 0',
                fontSize: '14px',
                color: '#f8f8f2',
                fontWeight: 400
              }}>
                <span style={{ minWidth: 120 }}>{row.cmd}</span>
                <span style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {row.keys.map((combo, j) => (
                    <span key={j} style={{ display: 'inline-flex', alignItems: 'center', gap: '0' }}>
                      {combo.map((k, kidx) => (
                        <React.Fragment key={kidx}>
                          {kidx > 0 && k === '+' && (
                            <span style={{ color: '#f8f8f2', fontWeight: 700, fontSize: '15px', margin: '0 6px', background: 'none', border: 'none', padding: 0 }}>+</span>
                          )}
                          {k !== '+' && k !== 'POINTER_ICON' && (
                            <span style={{
                              background: '#23242b',
                              border: '1px solid #44475a',
                              borderRadius: '6px',
                              color: '#f8f8f2',
                              fontWeight: 500,
                              fontSize: '13px',
                              padding: '2px 8px',
                              marginRight: kidx < combo.length - 1 && combo[kidx + 1] !== '+' ? '2px' : 0,
                              boxShadow: '0 1px 2px #0002',
                              letterSpacing: '0.5px',
                              display: 'inline-block',
                              minWidth: '22px',
                              textAlign: 'center'
                            }}>{k === '←' ? '←' : k === '→' ? '→' : k}</span>
                          )}
                          {k === 'POINTER_ICON' && (
                            <span style={{
                              background: '#23242b',
                              border: '1px solid #44475a',
                              borderRadius: '6px',
                              color: '#f8f8f2',
                              fontWeight: 500,
                              fontSize: '13px',
                              padding: '2px 8px',
                              marginRight: kidx < combo.length - 1 ? '2px' : 0,
                              boxShadow: '0 1px 2px #0002',
                              letterSpacing: '0.5px',
                              display: 'inline-block',
                              textAlign: 'center'
                            }}>Click</span>
                          )}
                        </React.Fragment>
                      ))}
                    </span>
                  ))}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Video/Timeline Area */}
      <div 
        style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          flexShrink: 1, // Allow shrinking to fit content
          minHeight: 0, // Allow proper flex behavior
          flexGrow: 1, // Take up remaining space
          overflow: 'visible', // Allow timeline to be visible
          justifyContent: 'flex-start' // Align to top
        }}
      >
        <div
          className="video-wrapper"
          style={{
            position: 'relative',
            width: '1280px', // Fixed size - doesn't change with zoom
            height: '720px', // Fixed size - doesn't change with zoom
            border: '2px solid #6272a4',
            cursor: isPaused ? 'crosshair' : 'default',
            userSelect: 'none',
            overflow: 'hidden',
            flexShrink: 0, // Prevent shrinking
            transformOrigin: 'top left'
          }}
          onWheel={handleWheel}
        >
          {videoUrl ? (
            <>
              {/* Video content with zoom and pan */}
              <div
                style={{
                  width: '1280px',
                  height: '720px',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  transform: `translate(${-pan.x}px, ${-pan.y}px) scale(${zoom})`,
                  transformOrigin: 'top left',
                  pointerEvents: 'none',
                }}
              >
                {/* Video Player Layer */}
                <div
                  data-vjs-player
                  style={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 1,
                    pointerEvents: 'none',
                  }}
                >
                  <video
                    ref={videoRef}
                    style={{ 
                      width: '100%', 
                      height: '100%', 
                      pointerEvents: 'none',
                      cursor: 'crosshair'
                    }}
                    muted
                  />
                </div>
                {/* Annotation Display Layer - inside zoomed content, use native-to-display mapping */}
                {currentAnnotations.map(annotation => {
                  const videoElement = videoRef.current;
                  const displayWidth = 1280;
                  const displayHeight = 720;
                  const nativeWidth = videoElement ? videoElement.videoWidth : displayWidth;
                  const nativeHeight = videoElement ? videoElement.videoHeight : displayHeight;
                  
                  // Convert from native video coordinates to display coordinates
                  const displayX = (annotation.x / nativeWidth) * displayWidth;
                  const displayY = (annotation.y / nativeHeight) * displayHeight;
                  
                  // Get color based on type
                  const getColor = (type) => {
                    switch (type) {
                      case 'stroke': return '#ffb86c';
                      case 'bounce': return '#8be9fd';
                      case 'in-flight': return '#ff79c6';
                      case 'net': return '#bd93f9';
                      default: return '#f8f8f2';
                    }
                  };
                  
                  return (
                    <div
                      key={annotation.id}
                      style={{
                        position: 'absolute',
                        left: Math.round(displayX - 10),
                        top: Math.round(displayY - 10),
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: 'transparent',
                        border: `3px solid ${getColor(annotation.type)}`,
                        pointerEvents: 'none',
                        zIndex: 3,
                        boxSizing: 'border-box',
                      }}
                    />
                  );
                })}
              </div>
              {/* Annotation Layer (for clicks) */}
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '1280px',
                  height: '720px',
                  zIndex: 4,
                  pointerEvents: isPaused ? 'auto' : 'none',
                  cursor: isPaused ? 'crosshair' : 'default',
                  background: 'transparent',
                }}
                onClick={handleAnnotationClick}
              />
            </>
          ) : (
            <div style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              color: '#bd93f9',
              fontFamily: 'Roboto, sans-serif',
              fontSize: '28px',
              fontWeight: 500,
              letterSpacing: '0.5px',
              textAlign: 'center',
              background: '#23242b'
            }}>
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '18px' }}>
                <rect x="8" y="16" width="48" height="32" rx="6" fill="#44475a" stroke="#6272a4" strokeWidth="2"/>
                <polygon points="28,26 44,32 28,38" fill="#bd93f9" />
              </svg>
              Please enter a video URL to begin
            </div>
          )}
        </div>
        
        {/* Timeline and toolbar container */}
        <div 
          style={{
            marginTop: '20px',
            width: `${videoDisplayWidth}px`, // Match video width exactly
            backgroundColor: 'transparent',
            borderRadius: '8px',
            padding: 0,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxSizing: 'border-box',
            marginRight: '0', // Ensure flush with right edge
            flexShrink: 0, // Prevent shrinking
            marginBottom: '0px' // Remove bottom margin since we have container padding
          }}
        >
          {/* Timeline Row */}
          <div style={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative' }}>
            {/* Play/Pause Button - restyled */}
            <button
              ref={playButtonRef}
              onClick={handlePlayPauseClick}
              style={{
                position: 'absolute',
                left: '0px',
                width: '36px',
                height: '36px',
                backgroundColor: '#6272a4',
                border: '2px solid #f8f8f2',
                borderRadius: '50%',
                color: '#f8f8f2',
                fontSize: '18px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                outline: 'none',
                userSelect: 'none',
                zIndex: 10,
                boxShadow: '0 2px 8px #0002',
                padding: 0,
                flexShrink: 0 // Prevent shrinking
              }}
            >
              {playerRef.current && playerRef.current.paused() ? (
                <svg width="18" height="18" viewBox="0 0 18 18" style={{ display: 'block' }}>
                  <circle cx="9" cy="9" r="9" fill="none" />
                  <polygon points="6,4 14,9 6,14" fill="#f8f8f2" />
                </svg>
              ) : (
                <svg width="18" height="18" viewBox="0 0 18 18" style={{ display: 'block' }}>
                  <circle cx="9" cy="9" r="9" fill="none" />
                  <rect x="5" y="4" width="3" height="10" rx="1" fill="#f8f8f2" />
                  <rect x="10" y="4" width="3" height="10" rx="1" fill="#f8f8f2" />
                </svg>
              )}
            </button>
            {/* Scrollable Timeline */}
            <div
              ref={timelineScrollRef}
              className="timeline-scroll"
              style={{
                width: 'calc(100% - 170px)', // Account for play button (50px) and time labels (120px)
                marginLeft: '50px', // Start after play button
                height: '40px',
                overflowX: 'auto',
                overflowY: 'hidden',
                backgroundColor: '#282a36',
                borderRadius: '10px',
                position: 'relative',
                whiteSpace: 'nowrap',
                boxSizing: 'border-box',
                // Cross-browser scrollbar styling
                scrollbarWidth: 'thin', // Firefox
                scrollbarColor: '#6272a4 #282a36', // Firefox
              }}
              onScroll={handleTimelineScroll}
              onWheel={handleTimelineWheel}
            >
              {/* Custom scrollbar styling for WebKit browsers (Chrome, Safari) */}
              <style>{`
                .timeline-scroll::-webkit-scrollbar {
                  height: 8px;
                }
                .timeline-scroll::-webkit-scrollbar-track {
                  background: #282a36;
                  border-radius: 4px;
                }
                .timeline-scroll::-webkit-scrollbar-thumb {
                  background: #6272a4;
                  border-radius: 4px;
                }
                .timeline-scroll::-webkit-scrollbar-thumb:hover {
                  background: #7c8db8;
                }
              `}</style>
              <div
                style={{
                  width: `${timelineBarWidth}px`,
                  height: '100%',
                  position: 'relative',
                  backgroundColor: timelineZoom !== 1 ? '#44475a' : '#282a36',
                  borderRadius: '10px',
                  cursor: 'pointer'
                }}
                onClick={handleTimelineClick}
              >
                {/* Progress Bar */}
                <div
                  style={{
                    width: `${(currentTime / videoDuration) * 100}%`,
                    height: '100%',
                    backgroundColor: '#6272a4',
                    borderRadius: '10px',
                    transition: 'width 0.1s ease',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    zIndex: 1
                  }}
                />
                {/* Side Switch Bars */}
                {sideSwitches.map((sw, index) => {
                  const startTime = index === 0 ? 0 : sideSwitches[index - 1].timestamp;
                  const endTime = sw.timestamp;
                  const startPos = (startTime / videoDuration) * timelineBarWidth;
                  const width = ((endTime - startTime) / videoDuration) * timelineBarWidth;
                  
                  // Get the correct colors for this segment
                  const topColor = index === 0 ? '#ff5555' : sideSwitches[index - 1].topPlayer === 'red' ? '#ff5555' : '#50fa7b';
                  const bottomColor = index === 0 ? '#50fa7b' : sideSwitches[index - 1].topPlayer === 'red' ? '#50fa7b' : '#ff5555';
                  
                  return (
                    <div
                      key={sw.id}
                      style={{
                        position: 'absolute',
                        left: `${startPos}px`,
                        width: `${width}px`,
                        height: '100%',
                        background: 'transparent',
                        borderTop: `4px solid ${topColor}`,
                        borderBottom: `4px solid ${bottomColor}`,
                        boxSizing: 'border-box',
                        zIndex: 2
                      }}
                    />
                  );
                })}
                {/* Last section to end of timeline */}
                {sideSwitches.length > 0 && (
                  <div
                    style={{
                      position: 'absolute',
                      left: `${(sideSwitches[sideSwitches.length - 1].timestamp / videoDuration) * timelineBarWidth}px`,
                      width: `${timelineBarWidth - (sideSwitches[sideSwitches.length - 1].timestamp / videoDuration) * timelineBarWidth}px`,
                      height: '100%',
                      background: 'transparent',
                      borderTop: `4px solid ${sideSwitches[sideSwitches.length - 1].topPlayer === 'red' ? '#ff5555' : '#50fa7b'}`,
                      borderBottom: `4px solid ${sideSwitches[sideSwitches.length - 1].topPlayer === 'red' ? '#50fa7b' : '#ff5555'}`,
                      boxSizing: 'border-box',
                      zIndex: 2
                    }}
                  />
                )}
                {/* Initial section if no switches */}
                {sideSwitches.length === 0 && (
                  <div
                    style={{
                      position: 'absolute',
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: 'transparent',
                      borderTop: '4px solid #ff5555',
                      borderBottom: '4px solid #50fa7b',
                      boxSizing: 'border-box',
                      zIndex: 2
                    }}
                  />
                )}
                {/* Side Switch Markers */}
                {sideSwitches.map(sw => {
                  const markerPosition = (sw.timestamp / videoDuration) * timelineBarWidth;
                  return (
                    <div
                      key={`marker-${sw.id}`}
                      style={{
                        position: 'absolute',
                        left: `${markerPosition}px`,
                        top: 0,
                        width: '2px',
                        height: '100%',
                        backgroundColor: '#f8f8f2',
                        transform: 'translateX(-50%)',
                        zIndex: 3,
                        cursor: 'pointer'
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        playerRef.current.currentTime(sw.timestamp);
                      }}
                      title={`Side Switch at ${formatTime(sw.timestamp)}`}
                    />
                  );
                })}
                {/* Annotation Markers */}
                {annotations.map(annotation => {
                  const markerPosition = (annotation.timestamp / videoDuration) * timelineBarWidth;
                  const getColor = (type) => {
                    switch (type) {
                      case 'stroke': return '#ffb86c';
                      case 'bounce': return '#8be9fd';
                      case 'in-flight': return '#ff79c6';
                      case 'net': return '#bd93f9';
                      default: return '#f8f8f2';
                    }
                  };
                  return (
                    <div
                      key={annotation.id}
                      style={{
                        position: 'absolute',
                        left: `${markerPosition}px`,
                        top: '4px',
                        width: '4px',
                        height: '32px',
                        backgroundColor: getColor(annotation.type),
                        borderRadius: '2px',
                        cursor: 'pointer',
                        transform: 'translateX(-50%)',
                        zIndex: 2
                      }}
                      title={`${annotation.type.charAt(0).toUpperCase() + annotation.type.slice(1)} at ${formatTime(annotation.timestamp)}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (playerRef.current) {
                          playerRef.current.currentTime(annotation.timestamp);
                          // Snap to the exact annotation timestamp
                          setTimeout(() => {
                            if (playerRef.current) {
                              playerRef.current.pause();
                              playerRef.current.currentTime(annotation.timestamp);
                            }
                          }, 10);
                        }
                      }}
                    />
                  );
                })}
                {/* Current Time Indicator */}
                <div
                  style={{
                    position: 'absolute',
                    left: `${(currentTime / videoDuration) * timelineBarWidth}px`,
                    top: 0,
                    width: '2px',
                    height: '100%',
                    backgroundColor: '#f8f8f2',
                    transform: 'translateX(-50%)',
                    zIndex: 4
                  }}
                />
              </div>
            </div>
            {/* Time Labels */}
            <div style={{
              position: 'absolute',
              right: '0px',
              fontSize: '12px',
              color: '#f8f8f2',
              minWidth: '120px',
              textAlign: 'right',
              fontFamily: 'Roboto, sans-serif',
              fontWeight: '400',
              flexShrink: 0,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              gap: '2px'
            }}>
              <span>{formatTime(currentTime)}</span>
              <span style={{
                fontSize: '10px',
                color: '#6272a4',
                fontWeight: '400'
              }}>
                {timelineZoom.toFixed(2)}x • {formatTime(visibleTimeWindow)} window
              </span>
            </div>
          </div>
          {/* Toolbar Row - Single set of navigation buttons for all events */}
          <div style={{
            width: '100%',
            height: '48px',
            background: '#44475a',
            borderRadius: '0 0 8px 8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            marginTop: '0px',
            boxShadow: '0 2px 8px #0002',
            flexShrink: 0
          }}>
            {/* Previous Event Button */}
            <button
              onClick={() => {
                // Combine annotations and side switches for navigation
                const allEvents = [
                  ...annotations.map(a => ({ ...a, eventType: 'annotation' })),
                  ...sideSwitches.map(s => ({ ...s, eventType: 'side_switch' }))
                ];
                const prev = allEvents
                  .filter(e => e.timestamp < currentTime)
                  .sort((a, b) => b.timestamp - a.timestamp)[0];
                if (prev && playerRef.current) {
                  playerRef.current.currentTime(prev.timestamp);
                }
              }}
              disabled={annotations.filter(a => a.timestamp < currentTime).length === 0 && 
                       sideSwitches.filter(s => s.timestamp < currentTime).length === 0}
              style={{
                width: '40px',
                height: '40px',
                background: 'none',
                border: 'none',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: (annotations.filter(a => a.timestamp < currentTime).length === 0 && 
                        sideSwitches.filter(s => s.timestamp < currentTime).length === 0) ? 'not-allowed' : 'pointer',
                opacity: (annotations.filter(a => a.timestamp < currentTime).length === 0 && 
                         sideSwitches.filter(s => s.timestamp < currentTime).length === 0) ? 0.4 : 1,
                outline: 'none',
                userSelect: 'none',
                transition: 'background 0.2s',
                fontSize: '24px',
                color: '#f8f8f2',
              }}
              title="Previous Event"
            >
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="14" r="13" stroke="#6272a4" strokeWidth="2" fill="#282a36" />
                <polyline points="17,8 11,14 17,20" fill="none" stroke="#f8f8f2" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            {/* Next Event Button */}
            <button
              onClick={() => {
                // Combine annotations and side switches for navigation
                const allEvents = [
                  ...annotations.map(a => ({ ...a, eventType: 'annotation' })),
                  ...sideSwitches.map(s => ({ ...s, eventType: 'side_switch' }))
                ];
                const next = allEvents
                  .filter(e => e.timestamp > currentTime)
                  .sort((a, b) => a.timestamp - b.timestamp)[0];
                if (next && playerRef.current) {
                  playerRef.current.currentTime(next.timestamp);
                }
              }}
              disabled={annotations.filter(a => a.timestamp > currentTime).length === 0 && 
                       sideSwitches.filter(s => s.timestamp > currentTime).length === 0}
              style={{
                width: '40px',
                height: '40px',
                background: 'none',
                border: 'none',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: (annotations.filter(a => a.timestamp > currentTime).length === 0 && 
                        sideSwitches.filter(s => s.timestamp > currentTime).length === 0) ? 'not-allowed' : 'pointer',
                opacity: (annotations.filter(a => a.timestamp > currentTime).length === 0 && 
                         sideSwitches.filter(s => s.timestamp > currentTime).length === 0) ? 0.4 : 1,
                outline: 'none',
                userSelect: 'none',
                transition: 'background 0.2s',
                fontSize: '24px',
                color: '#f8f8f2',
              }}
              title="Next Event"
            >
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="14" r="13" stroke="#6272a4" strokeWidth="2" fill="#282a36" />
                <polyline points="11,8 17,14 11,20" fill="none" stroke="#f8f8f2" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      {/* Logos at the bottom left, horizontal layout */}
      <div style={{
        position: 'fixed',
        left: 24,
        bottom: 24,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '20px',
        zIndex: 9999,
        pointerEvents: 'none',
      }}>
        <img src="/images/logo%20SplitStep,%20symbol%2003.png" alt="SplitStep Logo" style={{ height: 40, objectFit: 'contain', filter: 'drop-shadow(0 2px 8px #0008)' }} />
        <img src="/images/logo%20Wyatt%20AI%20wide,%20dark.png" alt="Wyatt AI Logo" style={{ height: 40, objectFit: 'contain', filter: 'drop-shadow(0 2px 8px #0008)' }} />
      </div>
    </div>
  );
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  if (!isLoggedIn) {
    return <LoginPage onLogin={handleLogin} />;
  }
  
  return <VideoPlayer />;
}

const container = document.getElementById('root');
if (container) {
const root = createRoot(container);
root.render(<App />);
} else {
  console.error('Root container not found');
}